import { useEffect } from "react";
import { useRawTable } from "../../hooks";
import moment from "moment";

export default function Module_ElderlyHealth_ElderlyHealthCaseList({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  totalRecord,
  callMainAPI,
  isResetPage,
}) {
  const { setTbData, setTbFirstIndex, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
    subTitleBgColor: "elderlytitle2",
  });

  useEffect(() => {
    if (!isResetPage) return;

    setTbFirstIndex(0);
  }, [isResetPage]);

  useEffect(() => {
    if (!apiData) return;

    const keepLatestByPID = (data) => {
      return Object.values(
        data.reduce((acc, curr) => {
          const pid = curr["個案編號"];
          // 如果還沒有這個 PID 或當前日期比已存的日期新
          if (
            !acc[pid] ||
            new Date(curr["填答時間"]) > new Date(acc[pid]["填答時間"])
          ) {
            acc[pid] = curr;
          }
          return acc;
        }, {})
      ).map((item) => ({
        ...item,
        長期照顧個案核定日期: item["長期照顧個案核定日期"]
          ? moment(item["長期照顧個案核定日期"]).format("YYYY-MM-DD")
          : "-",
        居住長照機構入住日期: item["居住長照機構入住日期"]
          ? moment(item["居住長照機構入住日期"]).format("YYYY-MM-DD")
          : "-",
        死亡日期: item["死亡日期"]
          ? moment(item["死亡日期"]).format("YYYY-MM-DD")
          : "-",
      }));
    };

    let formatData = keepLatestByPID(apiData);

    setTbData({
      raw: formatData,
      format: null,
      export: formatData,
      totalRecord: formatData.length,
    });
  }, [apiData, exportData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
        isLazy: true,
        isPaginator: true,
        callMainAPI: null,
      })}
    </>
  );
}
